import Pagination from './pagination';

export default Pagination;
export type * from './types';
